import {Component, Injector, OnInit} from '@angular/core';

@Component({
  selector: 'asistencia-director-curso-barra',
  standalone: false,
  template: `
    <div class="header-mainInfo">
      <h1 class="control-item">Asistencia</h1>
      <span class="header-mainInfo__separator">/</span>
      <h1 class="">Curso {{curso.nickName}}</h1>
      <span class="spacer"></span>
      <button mat-icon-button [ngStyle]="{'opacity': showSidebar ? '1' : '.6'}">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>`
})

export class AsistenciaDirectorCursoBarraComponent implements OnInit {

  curso: any;

  showSidebar = true;

  constructor(private injector: Injector) {
  }

  ngOnInit() {
    this.curso = this.injector.get('curso');
  }
}
